import CarIcon from 'components/elements/icons/CarIcon'
import RequesterIcon from 'components/elements/icons/RequesterIcon'
import MapTemplate from 'components/templates/MapTemplate'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import { PAGE_PATH } from 'constants/pagePath'
import { VEHICLE_STATE } from 'constants/qnState'
import { HistoryStackContext } from 'contexts/HistoryStackContext'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { QnStatesProps } from 'states/QnState'
import { StatesProps } from 'utils/commonHooks'
import { updateLog } from 'utils/log'
import { StatusProps } from 'utils/status'
import { useEditQnState } from '../../../utils/commonHooks'

const TITLE = '車の場所選択画面'

const troubleScreenPath: Record<string, string> = {
  [VEHICLE_STATE.ACCIDENT]: PAGE_PATH.ACCIDENT,
  [VEHICLE_STATE.EMPTY_FUEL]: PAGE_PATH.EMPTY_FUEL,
  [VEHICLE_STATE.ENGINE_TROUBLE]: PAGE_PATH.ENGINE_TROUBLE,
  [VEHICLE_STATE.FALLING_WHEEL]: PAGE_PATH.FALLING_WHEEL,
  [VEHICLE_STATE.FLAT_TIRE]: PAGE_PATH.FLAT_TIRE,
  [VEHICLE_STATE.LOSS_KEY]: PAGE_PATH.LOSS_KEY,
  [VEHICLE_STATE.OTHERS]: PAGE_PATH.OTHERS,
}

/** 車の場所選択画面のボタンラベル */
const TROUBLE_PLACE_BUTTON_LABEL = 'トラブル場所に設定する'

/**
 * QN-04:車の場所選択画面
 */
const TroublePlace: React.FC<StatesProps> = (props: QnStatesProps) => {
  const { state, setState } = props
  const historyStackContext = useContext(HistoryStackContext)
  const [location, setLocation] = useState(state.location)
  const [isDisabled, setIsDisabled] = useState(false)
  const [editingItem, ,] = useEditQnState()

  const forwardAction = useCallback((): StatusProps => {
    updateLog(TITLE, { location }, historyStackContext)
    const updateState = {
      ...state,
      location: { ...location, isSelected: true },
    }
    if (!state.destinationLocation.isSelected) {
      updateState.destinationLocation = {
        ...location,
        isSelected: false,
      }
    }
    return setState(updateState)
  }, [state, location, historyStackContext, setState])

  useEffect(() => {
    updateLog(TITLE, { location: state.location }, historyStackContext)
  }, [historyStackContext, state.location])

  const forwardTo = React.useMemo(() => {
    return state.confirmationChangeType
      ? PAGE_PATH.CONFIRMATION
      : PAGE_PATH.TROUBLE_PLACE_SURROUNDING
  }, [])

  const backTo = React.useMemo(() => {
    return state.confirmationChangeType
      ? PAGE_PATH.CONFIRMATION
      : troubleScreenPath[editingItem.vehicleState || PAGE_PATH.VEHICLE_STATE]
  }, [state.vehicleState])

  return (
    <MapTemplate
      title={TITLE}
      usingGeolocation
      location={location}
      setLocation={setLocation}
      setIsDisabled={setIsDisabled}
      markerComponent={<RequesterIcon />}
      addressComponent={<CarIcon color={CLIENT_SETTINGS.colors.iconCar} />}
      forwardLabel={TROUBLE_PLACE_BUTTON_LABEL}
      forwardTo={forwardTo}
      forwardAction={forwardAction}
      isDisabled={isDisabled}
      disabledLabel={TROUBLE_PLACE_BUTTON_LABEL}
      showBack
      backTo={backTo}
      notClearEditingItem
    />
  )
}

export default TroublePlace
